<div class="app-margin" *ngIf="asset && asset.code">

  <ng-container *ngIf="asset.main_image_url">
    <div class="container-fluid mb-4">
      <h6>Asset Image</h6>
      <div class="row">
        <div class="col-12">
          <img [src]="asset.main_image_url" class="profile-picture" [alt]="asset.main_image_name" />
        </div>
      </div>
    </div>
  </ng-container>

  <h6>Name</h6>
  <p>{{ asset.name }}</p>

  <h6>Code</h6>
  <p>{{ asset.code }}</p>

  <h6>Type</h6>
  <p>
    <ng-container *ngIf="asset?.parent_asset_type_name">
      <span class="mr-2">{{ asset.parent_asset_type_name }}</span>
      <span class="mr-1">&rarr;</span>
    </ng-container>
    {{ asset?.asset_type_name }}
  </p>

  <h6>Status</h6>
  <p><span [style.color]="assetsService.getStatusColor(asset.status) || null">{{  assetsService.getStatusLabel(asset.status) }}</span></p>

  <h6>Condition Rating</h6>
  <p><span [style.color]="assetsService.getConditionColor(asset.condition_rating) || null">{{  assetsService.getConditionLabel(asset.condition_rating) }}</span></p>

  <ng-container *ngIf="asset.description">
    <h6>Description</h6>
    <p class="multiline-text">{{ asset.description }}</p>
  </ng-container>

  <ng-container *ngIf="asset.serial_no">
    <h6>Serial Number</h6>
    <p>{{ asset.serial_no }}</p>
  </ng-container>

  <ng-container *ngIf="asset.part_no">
    <h6>Part Number</h6>
    <p>{{ asset.part_no }}</p>
  </ng-container>

  <ng-container *ngIf="asset.vehicle_reg_no">
    <h6>Vehicle Registration Number</h6>
    <p>{{ asset.vehicle_reg_no }}</p>
  </ng-container>

  <ng-container *ngIf="asset.noise_rating_db">
    <h6>Noise Rating</h6>
    <p>{{ asset.noise_rating_db }} dB</p>
  </ng-container>

  <ng-container *ngIf="asset.emissions_class">
    <h6>Emissions Class</h6>
    <p>{{ asset.emissions_class }}</p>
  </ng-container>

  <ng-container *ngIf="asset.emergency_shutdown_procedure">
    <h6>Emergency Shutdown Procedure</h6>
    <p class="multiline-text">{{ asset.emergency_shutdown_procedure }}</p>
  </ng-container>

  <ng-container *ngIf="asset?.site_name">
    <h6>{{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}</h6>
    <p>{{ asset.site_name }}</p>
  </ng-container>

  <ng-container *ngIf="asset?.employer_name">
    <h6>Company</h6>
    <p>{{ asset.employer_name }}</p>
  </ng-container>
</div>
